export default "__VITE_ASSET__DN3BHHok__"